import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGridSingleSelectOption = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	fill: "currentColor",
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: -21927e-19,
			width: 20,
			height: 9.3335,
			rx: .99999,
			fill: "current",
			strokeWidth: .99999
		}),
		/* @__PURE__ */ _jsx("path", { d: "m1 10.668c-.554 0-1 .446-1 1v7.334c0 .554.446 1 1 1h18c.554 0 1-.446 1-1v-7.334c0-.554-.446-1-1-1h-5.0781l-3.7461 3.7461-3.7461-3.7461z" })
	]
});
const ForwardRef = forwardRef(SvgGridSingleSelectOption);
export { ForwardRef as ReactComponent };
